import {createContext, type Context, useContext} from 'react'

const OrganizationContext: Context<null> = createContext(null)
export const useOrganizationContext = () => useContext(OrganizationContext)
export default OrganizationContext
